import { Typography } from "antd";
import { ComponentPropsWithoutRef, CSSProperties } from "react";

export const InputHelperText = ({
  children,
  style,
}: ComponentPropsWithoutRef<typeof Typography.Text> & {
  style?: CSSProperties;
}) => {
  return (
    <Typography.Text style={{ fontSize: "0.8rem", ...style }} type="secondary">
      {children}
    </Typography.Text>
  );
};
